export const CallingStatus={
  "Unreachable": { value: "Unreachable",  },
  "Idle": { value: "Idle"},
  "Answered": { value: "Answered",  }
}
